<template>
  <v-dialog v-model="visible" max-width="30vw" @input="backToParent($event)">
    <v-card id="update_device_card" class="rounded-lg">
      <v-card-title>
        {{ $t('devices.title.update') }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-list-item>
        <v-list-item-content>
          <v-form ref="deviceForm" v-model="deviceFormValid">
            <v-text-field
              id="description"
              v-model="device.friendlyName"
              :label="$t('devices.content.friendlyName')"
              :counter="maxCharacters"
              :rules="[rules.required, rules.minMax]"
            ></v-text-field>
            <v-switch
              id="enabled"
              v-model="device.enabled"
              :label="device.enabled ? $t('devices.content.statusEnumLong.enabled') : $t('devices.content.statusEnumLong.disabled')"
              inset
              class="mx-3"
            ></v-switch>
          </v-form>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-btn @click="back">{{ $t('main.cancel') }}</v-btn>
        <v-btn id="update_button" color="primary" :disabled="!deviceFormValid" @click="updateDevice">
          {{ $t('main.update') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import devices from '../../services/api/devices'
import { showToastSuccess, showToastError } from '../../event-bus'

export default {
  name: 'UpdateDevice',

  data() {
    return {
      visible: true,
      deviceFormValid: false,
      minCharacters: 4,
      maxCharacters: 255,
      device: {},
      rules: {
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        minMax: (v) => ((v && v.length >= this.minCharacters) && (v && v.length <= this.maxCharacters)) || this.$t('validation.form.mustBeBetween', { min: this.minCharacters, max: this.maxCharacters })
      }
    }
  },

  mounted() {
    this.getDevice()
  },

  methods: {
    async updateDevice() {
      if (!this.$refs.deviceForm.validate()) {
        return
      }

      try {
        await devices.updateDevice(this.$route.params.deviceId, this.device)
        showToastSuccess(this.$t('toastMessage.succesfullyUpdated'))
        this.back()
      } catch (error) {
        showToastError(this.getErrorMessage(error))
      }
    },

    async getDevice() {
      try {
        this.device = await devices.getDevice(this.$route.params.deviceId)
      } catch (error) {
        showToastError(this.getErrorMessage(error))
      }
    },

    backToParent(e) {
      if (!e) {
        this.$router.go(-1)
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
</style>
